/* Copyright (c) 2023 MOCA Systems, Inc. All rights reserved. */
import { environment } from 'src/environments/environment-variables';

export const fullFirebasePath = environment.firebase.databaseURL + environment.refUrl;

/** 'yourUserId@https://firebase-app.com/Root' */
export const getAnalyticsDecoratedUserId = (userId: string) => {
	return userId + '@' + fullFirebasePath;
};
